(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["single-column-media"] && !Shopify.designMode) return;
  try {
    function initProductSlider() {

  if ($('.slider-for').hasClass('slick-initialized')) return;

  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    adaptiveHeight: true,
    asNavFor: '.slider-nav'
  });

  $('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true
  });
}

document.addEventListener('DOMContentLoaded', initProductSlider);
document.addEventListener('shopify:section:load', initProductSlider);
  } catch(e) { console.error(e); }
})();

})();
